import { Reveal, Eyebrow } from "./Reveal";
import { useT } from "@/lib/i18n";

const TXT = {
  no: {
    steps: [
      ["Kontakt", "Ring eller send en forespørsel med bilmerke, modell og årsmodell."],
      ["Diagnose", "Vi leser av bilen og finner riktig løsning for nøkkel, startsperre eller programvare."],
      ["Utførelse", "Nøkkelfresing, programmering eller kalibrering med profesjonelt verktøy."],
      ["Kontroll", "Alt testes før du kjører hjem: start, fjernkontroll og kjøreegenskaper."],
    ],
    eyebrow: "Prosess", h2a: "Fire steg.", h2b: "Null gjetting.", alt: "Keyless-nøkkel i kupé",
  },
  en: {
    steps: [
      ["Contact", "Call or send an inquiry with car make, model and year."],
      ["Diagnosis", "We read the car and find the right solution for the key, immobiliser or software."],
      ["Execution", "Key cutting, programming or calibration with professional tools."],
      ["Check", "Everything is tested before you drive home: starting, remote and driving behaviour."],
    ],
    eyebrow: "Process", h2a: "Four steps.", h2b: "Zero guesswork.", alt: "Keyless key in the cabin",
  },
};

export const Process = () => {
  const t = useT(TXT);
  const STEPS = t.steps.map(([title, d], i) => ({ n: `0${i + 1}`, t: title, d }));
  return (
  <section id="prosess" data-testid="process-section" className="mx-auto max-w-7xl px-5 py-24 sm:px-8 md:py-36">
    <div className="grid gap-14 lg:grid-cols-12">
      <Reveal className="lg:col-span-5">
        <Eyebrow index="06">{t.eyebrow}</Eyebrow>
        <h2 className="font-display text-5xl font-black uppercase leading-[0.9] md:text-7xl">{t.h2a}<br />{t.h2b}</h2>
        <div className="clip-slant relative mt-10 aspect-[4/3] overflow-hidden">
          <img src="/img/cockpit.webp" loading="lazy" alt={t.alt} className="h-full w-full object-cover" />
          <div className="absolute inset-0 bg-[#08090b]/30" />
        </div>
      </Reveal>
      <ol className="lg:col-span-7 lg:pt-24">
        {STEPS.map((s, i) => (
          <Reveal key={s.n} delay={i * 0.08}>
            <li data-testid={`process-step-${s.n}`}
              className="group grid grid-cols-[auto_1fr] gap-6 border-t border-white/10 py-8 transition-colors hover:border-[var(--red)] md:gap-10">
              <span className="font-mono text-sm text-[var(--red)]">{s.n}</span>
              <div>
                <h3 className="font-display text-4xl font-black uppercase leading-none transition-transform duration-500 group-hover:translate-x-2 md:text-5xl">{s.t}</h3>
                <p className="mt-3 max-w-md text-base leading-relaxed text-zinc-300">{s.d}</p>
              </div>
            </li>
          </Reveal>
        ))}
      </ol>
    </div>
  </section>
  );
};
